import { useCallback, useEffect, useRef, useState } from 'react'

import { isScenarioActive } from './scenario'
import type { MocktailScenario } from './scenario'
import { readScenario, writeScenario } from './store/scenarioStore'

export function useMocktailScenario(): {
  scenario: MocktailScenario
  setScenario: (updater: (prev: MocktailScenario) => MocktailScenario) => void
} {
  const [scenario, setScenarioState] = useState<MocktailScenario>(readScenario)
  // Tracks whether this hook has ever started the worker, so opening the dialog without
  // activating anything (the common case) never has to load the MSW chunk just to no-op a stop.
  const hasStartedWorkerRef = useRef(false)

  useEffect(() => {
    writeScenario(scenario)

    if (isScenarioActive(scenario)) {
      hasStartedWorkerRef.current = true
      void import('./engine/mocktailWorker').then(({ startMocktailWorker }) =>
        startMocktailWorker(),
      )
    } else if (hasStartedWorkerRef.current) {
      void import('./engine/mocktailWorker').then(({ stopMocktailWorker }) =>
        stopMocktailWorker(),
      )
    }
  }, [scenario])

  const setScenario = useCallback(
    (updater: (prev: MocktailScenario) => MocktailScenario): void => {
      setScenarioState(updater)
    },
    [],
  )

  return { scenario, setScenario }
}
